module.exports = __webpack_public_path__ + "static/home_sphere-e6497efe55c39967f16921cf348bb577.png";